import * as types from './constants';

export const setUser = data => ({
  type: types.SET_USER,
  data
});

export const setUserId = userId => ({
  type: types.SET_USER_ID,
  userId
});

export const setIsAdminUser = isAdminUser => ({
  type: types.SET_IS_ADMIN_USER,
  isAdminUser
});

export const setUserMfa = data => ({
  type: types.SET_USER_MFA,
  data
});

export const setUserResaleId = resaleId => ({
  type: types.SET_USER_RESALE_ID,
  resaleId
});

export const handleLoading = status => ({
  type: types.HANDLE_LOADING,
  status
});

export const clearProfile = () => ({
  type: types.CLEAR_BASIC_INFORMATION
});

export const setUserRestrictions = (userRestrictions, profileId) => ({
  type: types.SET_USER_RESTRICTIONS,
  userRestrictions,
  profileId
});

export const setIsConsultNewPasswordTermsRequestDone = () => ({
  type: types.SET_IS_CONSULT_NEW_PASSWORD_TERMS_REQUEST_DONE
});

export const setIsConsultUserNewPasswordTermsRequestDone = () => ({
  type: types.SET_IS_CONSULT_USER_NEW_PASSWORD_TERMS_REQUEST_DONE
});

export const setUserOwnTerms = data => ({
  type: types.SET_USER_OWN_TERMS,
  data
});

export const setUserTermsNotAccepted = data => ({
  type: types.SET_IS_USER_TERMS_NOT_ACCEPTED,
  data
});